import * as React from 'react'

import { Box, Button, Spinner } from '@factorialco/deprecated-design-system'
import { groupBy } from 'lodash'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { useTimeSettingsCategory } from 'modules/attendance/lib/timeSettingsCategoryContext'
import { TimeBlocksBalanceCollection } from 'modules/attendance/store/models/TimeBlocksBalanceCollection'
import { UniqueTimeBlockData } from 'modules/attendance/store/models/UniqueTimeBlockData'

import CheckBoxForm from './Units/CheckBoxForm'

interface Props {
  onCloseModal: () => void
  onContinue: () => void
  onSelectTimeBlock: (category: UniqueTimeBlockData, checked: boolean) => void
  disableButton: boolean
  timeBlocksLoading: boolean
  timeBlocksBalance: TimeBlocksBalanceCollection
}

const TimeBlocks = ({
  onCloseModal,
  onContinue,
  onSelectTimeBlock,
  disableButton,
  timeBlocksLoading,
  timeBlocksBalance,
}: Props) => {
  const { pendingPayrollBlocks } = timeBlocksBalance.payrollCompensationPendingAndCompensated
  const { timeSettingsCategories } = useTimeSettingsCategory()
  const timeSettingsCategoryById = groupBy(
    timeSettingsCategories.activeCategories,
    (category) => category.id
  )

  return (
    <Modal
      illustration="monety-bag"
      title={i18n.t('clock_in.sidepanel.compensation.modal.time_blocks.title')}
      description={i18n.t('clock_in.sidepanel.compensation.modal.time_blocks.description')}
      footer={
        <>
          <Button type="secondary" onClick={onCloseModal}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={disableButton} submit>
            {i18n.t('common.continue')}
          </Button>
        </>
      }
      onClose={onCloseModal}
      onSubmit={onContinue}
    >
      {timeBlocksLoading ? (
        <Box padding="s40" alignItems="center">
          <Spinner size="s16" />
        </Box>
      ) : (
        <CheckBoxForm
          onSelectTimeBlock={onSelectTimeBlock}
          pendingBlocks={pendingPayrollBlocks}
          timeSettingsCategoryById={timeSettingsCategoryById}
        />
      )}
    </Modal>
  )
}

export default TimeBlocks
